import AuthActionContinue from './auth/AuthActionContinue';
import AuthActionStatus from './auth/AuthActionStatus';

function AuthEmailConfirmedPage() {
  return (
    <AuthActionStatus
      heading="Email confirmed ✓"
      body="You’re all set."
      footer={<AuthActionContinue continueTarget={{ kind: 'app-return' }} />}
    />
  );
}

export default AuthEmailConfirmedPage;
